/**
 * Provides bodymovin animation constants.
 */
import blackLogo from 'assets/animations/naked_loader_black.json';
import blackPulse from 'assets/animations/pulse_loader_black.json';
import bluePulse from 'assets/animations/small_loader_blue.json';
import greenPulse from 'assets/animations/pulse_loader_green.json';
import pinkPulse from 'assets/animations/small_loader_pink.json';
import whiteTransparentPulse from 'assets/animations/pulse_loader_white_transparent.json';

import { Colors } from './colors';

export type AnimationListType =
  | 'blackLogo'
  | 'blackPulse'
  | 'checkmark'
  | 'greenPulse'
  | 'orangePulse'
  | 'bluePulse'
  | 'pinkPulse'
  | 'splash'
  | 'whiteLogo'
  | 'whiteTransparentPulse';
export type AnimationsType = Record<AnimationListType, any>;
export type PulseLoaderType = Partial<Record<Colors, AnimationListType>>;

export const animations: AnimationsType = {
  blackLogo: blackLogo,
  blackPulse: blackPulse,
  bluePulse: bluePulse,
  checkmark: '',
  greenPulse: greenPulse,
  orangePulse: '',
  pinkPulse: pinkPulse,
  splash: '',
  whiteLogo: '',
  whiteTransparentPulse,
};

export const PulseLoaders: PulseLoaderType = {
  [Colors.blue]: 'bluePulse',
  [Colors.black]: 'blackPulse',
  [Colors.green]: 'greenPulse',
  [Colors.orange]: 'orangePulse',
  [Colors.pink]: 'pinkPulse',
};
